module.exports = __webpack_public_path__ + "img/13.79106a11.jpg";